/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Vak_OngeldigInputs */

const nl_planning_api_errors_vak_ongeldig = /** @type {(inputs: Planning_Api_Errors_Vak_OngeldigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit vak bestaat niet (meer) in de jaarplanning.`)
};

/**

* @param {Planning_Api_Errors_Vak_OngeldigInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_vak_ongeldig = /** @type {((inputs?: Planning_Api_Errors_Vak_OngeldigInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Vak_OngeldigInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_vak_ongeldig(inputs)
});
export { planning_api_errors_vak_ongeldig as "planning.api_errors.vak_ongeldig" }